export const aiMlGatewayRouteDef = [
  {
    path: 'ai-agent-registry',
    component: 'AiAgentRegistryComponent',
    data: { selector: 'app-ai-agent-registry', resource: 'ai_agent_registry', action: 'LIST' },
  },
  {
    path: 'ai-agent-registry/guided-setup',
    component: 'AiGuidedSetupWizardComponent',
    data: { selector: 'app-ai-guided-setup-wizard', resource: 'ai_guided_setup', action: 'LIST' },
  },
]